/* import __COLOCATED_TEMPLATE__ from './shopify-saved-draft-order.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();